import { render } from "./BacktestPausePanel.vue?vue&type=template&id=5623457a"
import script from "./BacktestPausePanel.vue?vue&type=script&lang=js"
export * from "./BacktestPausePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__